import React from 'react';
import { RewardsOffersDTO, useSpringBigStore } from '@springbig/shared';
import { HStack } from 'native-base';
import { useAppNavigate } from '~/pages';
import { Button } from '~/shared/Theme';

type ButtonsCardProps = {
    data: RewardsOffersDTO;
};

export const ButtonsCard = ({ data }: ButtonsCardProps) => {

    const { navigate, params } = useAppNavigate();
    const { member } = useSpringBigStore();

    return (
        <HStack flex={1} space={4}>
            { member.show_rewards &&
                <Button
                    text={'homepage.viewRewards'}
                    onPress={() => navigate(`w/${params.wallet_id}/rewards`)}
                    flex={1}
                />
            }
            { data.number_of_available_offers && data.number_of_available_offers !== 0 ?
                <Button
                    onPress={() => navigate(`w/${params.wallet_id}/offers`)}
                    flex={1} text={'homepage.viewOffers'}
                    textValues={[data.number_of_available_offers]}
                />
                :
                null
            }
        </HStack>
    );
};
